<template>
  <div>
    <div>
      <div>
        <p class="heading">六大操作流程</p>
        <ShowLine></ShowLine>
      </div>
    </div>
    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/流程-1.jpg" />
          <h2></h2>
          <div class="content_div">
            <h3>采购管理</h3>
            <div class="litter_line"></div>
            <p>· 制定采购计划</p>
            <p>· 下达物料</p>
            <p>· 选择供应商</p>
            <p>· 索要各类证书</p>
            <p>· 采购物料审批</p>
            <p>· 保鲜运输方式</p>
            <p>· 按标准验收</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/流程-2.jpg" />
          <div class="content_div">
            <h3>储存管理</h3>
            <div class="litter_line"></div>
            <p>· 分类及时入库</p>
            <p>· 建立入库档案</p>
            <p>· 科学存放</p>
            <p>· 凭单出库</p>
            <p>· 进出有序</p>
            <p>· 日盘点</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/流程-3.jpg" />
          <div class="content_div">
            <h3>洗消管理</h3>
            <div class="litter_line"></div>
            <p>· 农残检测</p>
            <p>· 去皮去根</p>
            <p>· 分类清洗</p>
            <p>· 盐水浸泡</p>
            <p>· 两次清洗</p>
            <p>· 即洗即用</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/流程-4.jpg" />
          <div class="content_div">
            <h3>加工管理</h3>
            <div class="litter_line"></div>
            <p>· 生熟分开</p>
            <p>· 荤素分开</p>
            <p>· 合理搭配</p>
            <p>· 及时清理卫生</p>
            <p>· 定时消毒</p>
            <p>· 规范流程</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/流程-5.jpg" />
          <div class="content_div">
            <h3>监督管理</h3>
            <div class="litter_line"></div>
            <p>· 岗位责任制</p>
            <p>· 营养搭配</p>
            <p>· 安全卫生</p>
            <p>· 操作规范</p>
            <p>· 菜品中心温度75℃</p>
            <p>· 留样48小时</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/流程-6.jpg" />
          <div class="content_div">
            <h3>售卖管理</h3>
            <div class="litter_line"></div>
            <p>· 统一着装</p>
            <p>· 佩戴口罩</p>
            <p>· 束发戴帽</p>
            <p>· 佩戴一次性口罩</p>
            <p>· 微笑贴心服务</p>
            <p>· 客户第一</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import ShowLine from "../../components/ShowLine.vue";
export default {
  components: {
    ShowLine,
  },
  data() {
    return {};
  },
  mounted() {
    this.Init();
  },
  destroyed() {},
  deactivated() {
    this.$destroy();
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      this.Init();
    },
  },
  methods: {
    Init() {},
    navto(path) {
      // $(".collapse.in").removeClass("in");
      this.$router.push(path);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleScroll() {
      $(".num").waypoint(
        () => {
          this.$refs.mynum1.start();
        },
        {
          offset: "80%",
        }
      );
      $(".mynum").waypoint(
        () => {
          this.$refs.mynum.start();
        },
        {
          offset: "80%",
        }
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
.bottommenu {
  background-color: #545c64;
}

.el-menu-demo {
  margin-top: 3px;
}

.elcol {
  padding: 0;
}

.heading {
  padding: 5rem 0 0 0;
  font-size: 4.8rem;
  color: var(--textBlue);
  text-align: center;
  font-family: bold;
}

.sub_heading {
  font-size: 1.5rem;
  color: var(--textBlue);
  text-align: center;
}

.tv_content {
  margin: auto;
  width: 60%;
  font-size: 1rem;
  color: #4c4948;
  text-align: center;
  line-height: 2rem;
}

.litter_line {
  display: inline-block;
  margin: 3rem 10rem 3rem 10rem;
  background-color: white;
  height: 0;
  width: 20% !important;
}

.father {
  width: 70vw;
  height: 50vh;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0;

    h3 {
      margin: 10rem 0 0 10rem;
      font-size: 3rem;
      font-family: bold;
    }

    p {
      margin: 0 10rem 0 10rem;
      width: auto;
      font-size: 14px;
      line-height: 3rem;
    }

    .first_p {
      margin: 10rem 10rem 0 10rem;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 17%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 10%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }
@media (min-width: 1300px) {
    .litter_line {
      margin: 4rem 5rem 1rem 5rem;
    }

    .content_div {
      h3 {
        margin: 5rem 0 0 5rem;
      }

      p {
        margin: 0 5rem 0 5rem;
        line-height: 2.5rem;
      }

      .first_p {
        margin: 5rem 5rem 0 5rem;
      }
    }
  }
  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>
